import { render, staticRenderFns } from "./ShowImage.vue?vue&type=template&id=8cc7056e&scoped=true&"
import script from "./ShowImage.vue?vue&type=script&lang=js&"
export * from "./ShowImage.vue?vue&type=script&lang=js&"
import style0 from "./ShowImage.vue?vue&type=style&index=0&id=8cc7056e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc7056e",
  null
  
)

export default component.exports